module.exports = __webpack_public_path__ + "static/media/vault_room.2f8981c3.jpg";